import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import type { PricingRegion } from '../pricing';

export interface PriceSheetLocation {
  id: string;
  name: string;
  city: string | null;
  state: string | null;
  region: PricingRegion;
}

export interface PriceSheetProduct {
  id: string;
  name: string;
}

export interface PriceSheetCell {
  available: boolean;
  region?: PricingRegion;
  kind?: 'delivered' | 'stone' | null;
  priceCents?: number | null;
}

export type DeliveryRate =
  | { kind: 'INCLUDED' }
  | { kind: 'RATE'; rateCents: number }
  | { kind: 'VARIES' }
  | { kind: 'NONE' };

export interface PriceSheet {
  pricingEnabled: boolean;
  visibleToCustomer: boolean;
  locations: PriceSheetLocation[];
  products: PriceSheetProduct[];
  cells: Record<string, Record<string, PriceSheetCell>>;
  deliveryRateByLocation: Record<string, DeliveryRate>;
}

export function usePriceSheet() {
  return useQuery({
    queryKey: ['price-sheet'],
    queryFn: async () => (await api.get('/products/price-sheet')).data as PriceSheet,
    staleTime: 60_000,
  });
}

/** Lightweight probe for the sidebar — whether to show the Price Sheet tab. */
export function usePriceSheetVisible(enabled = true) {
  return useQuery({
    queryKey: ['price-sheet', 'visible'],
    queryFn: async () =>
      ((await api.get('/products/price-sheet/visible')).data as { visible: boolean }).visible,
    enabled,
    staleTime: 5 * 60_000,
  });
}
